import { useFlags } from "components/FeatureFlag/useFlags";

export function useAutomatedSignUp() {
  const { loadingConfig, flags } = useFlags();

  return {
    loadingConfig: loadingConfig,
    automatedSignUp: flags?.["automated-sign-up"],
  };
}

export default useAutomatedSignUp;
